import { useRef } from 'react'

// This hook is used for React Portals for
// Inject dymamic component in real node
// Returns the node object DOM ref
export default function useRealNode (id) {
  const node = useRef(null)

  // Check if node already exists in DOM
  if (!node.current) {
    const existingNode = document.getElementById(id)
    
    if (existingNode) {
      node.current = existingNode
    } else {
      // Create new node if it doesn't exist
      node.current = document.createElement('div')
      node.current.setAttribute('id', id)
      document.body.appendChild(node.current)
    }
  }

  return node.current
}
